export default {
    "title": "🇸🇦 العربية",

    "首页": "الرئيسية",
    "关于": "حول",
    "会员": "العضوية",
    "推荐计划": "برنامج الإحالة",
    "个人": "الملف الشخصي",
    "推荐": "إحالة",
    "预订": "احجز الآن",
    "事件": "فعاليات",
    "登出": "تسجيل الخروج",
    "登录": "تسجيل الدخول",
    "注册": "تسجيل",
    "我们的应用程序现在可用": "تطبيقنا متاح الآن",
    "为了获得更好的体验，我们刚刚推出了移动应用程序，以实现无缝、更快的预订。": "لتحسين التجربة، أطلقنا للتو تطبيقات الجوال لحجز أسهل وأسرع.",
    "iOS版下载（即将推出）": "تنزيل iOS (قريبًا)",
    "Android版下载（即将推出）": "تنزيل Android (قريبًا)",
    "为什么选择我们": "لماذا تختارنا",
    "我们卓越的服务。": "خدماتنا المتميزة.",
    "收入最高的酒店": "أعلى الفنادق ربحًا",
    "我们的合作酒店收入最高。": "فنادقنا الشريكة ذات أعلى عوائد.",
    "回报": "عوائد",
    "最具特色的酒店": "أبرز الفنادق",
    "我们平台上最有特色的酒店。": "أكثر الفنادق تميزًا على منصتنا.",
    "热门国家和目的地": "أشهر البلدان والوجهات",
    "从我们的合作伙伴和朋友那里了解一些来自城市各地的最佳提示。": "استكشف أفضل النصائح من شركائنا وأصدقائنا عبر المدن.",
    "酒店": "فنادق",
    "预订酒店并开始赚取": "استكشف العالم معنا!",
    "让我们开始与TitanTraveler一起探索世界": "استعد لاستكشاف عالم الفنادق معنا!",
    "客户评价": "آراء العملاء",
    "查看我们用户的真实评价。": "اطّلع على تقييمات حقيقية من مستخدمينا.",
    "银行卡列表": "قائمة بطاقات البنك",
    "银行列表": "قائمة البنوك",
    "持卡人姓名": "اسم صاحب البطاقة",
    "银行卡号": "رقم الحساب البنكي (IBAN)",
    "支付密码": "كلمة مرور الدفع",
    "提交": "إرسال",
    "Pix列表": "قائمة Pix",
    "Pix类型": "نوع Pix",
    "Pix账号": "حساب Pix",
    "账号列表": "قائمة الحسابات",
    "网络": "الشبكة",
    "地址": "العنوان",
    "备注": "ملاحظة",
    "充值金额": "مبلغ الشحن",
    "支付类型": "نوع الدفع",
    "支付银行": "بنك الدفع",
    "USDT地址": "عنوان USDT",
    "二维码": "رمز QR",
    "充值渠道": "قناة الشحن",
    "充值凭证": "إثبات الشحن",
    "立即登录": "تسجيل الدخول الآن",
    "用户名": "اسم المستخدم",
    "密码": "كلمة المرور",
    "邀请码": "رمز الدعوة",
    "确认密码": "تأكيد كلمة المرور",
    "手机": "الهاتف المحمول",
    "注册2": "اشتراك",
    "金额": "المبلغ",
    "新增": "إضافة",
    "我们的精彩": "روعتنا",
    "故事": "قصة",
    "奖项": "جوائز",
    "获得": "تحقق",
    "钱包余额": "رصيد المحفظة",
    "累计佣金": "العمولات المتراكمة",
    "今日奖励": "مكافآت اليوم",
    "总行程": "إجمالي الرحلات",
    "访问行程": "الرحلات التي تمت زيارتها",
    "酒店历史": "تفاصيل الطلب",
    "单价": "السعر",
    "数量": "الكمية",
    "总额": "الإجمالي",
    "奖励": "مكافآت",
    "上一页": "السابق",
    "下一页": "التالي",
    "每套预订量": "حجوزات لكل مجموعة",
    "预订奖励": "مكافأة الحجز",
    "每日预订": "حجوزات يومية",
    "手机号码": "رقم الهاتف",
    "修改密码": "تغيير كلمة المرور",
    "登录密码": "كلمة مرور الدخول",
    "当前密码": "كلمة المرور الحالية",
    "新密码": "كلمة مرور جديدة",
    "确认新密码": "تأكيد كلمة المرور الجديدة",
    "保存修改": "حفظ التغييرات",
    "充值": "شحن",
    "我们的": "خاصتنا",
    "复制": "نسخ",
    "分享链接": "مشاركة الرابط",
    "搜索酒店": "ابحث عن فندق",
    "实际等级": "المستوى الفعلي",
    "升级": "ترقية",
    "已完成预订": "الحجوزات المكتملة",
    "登录时间": "وقت الدخول",
    "信誉分": "النقاط الائتمانية",
    "控制菜单": "قائمة التحكم",
    "提现": "سحب",
    "提现账号": "حساب السحب",
    "你确定要删除此账号吗": "هل أنت متأكد من حذف هذا الحساب؟",
    "你确定要删除此地址吗": "هل أنت متأكد من حذف هذا العنوان؟",
    "提示": "تلميح",
    "是": "نعم",
    "否": "لا",
    "全部": "الكل",
    "待处理": "قيد الانتظار",
    "冻结中": "مجمّد",
    "已完成": "مكتمل",
    "订阅": "اشترك",
    "希望在我们推出新模板或更新时收到通知。 只需注册，我们就会通过电子邮件向您发送通知。": "هل ترغب في تنبيهك عند إطلاق قالب جديد أو تحديث؟ فقط سجّل وسنرسل لك إشعارًا عبر البريد الإلكتروني.",
    "我们的伙伴": "شركاؤنا",
    "关于我们": "من نحن",
    "实时聊天支持": "دعم الدردشة الحية",
    "在线聊天": "دردشة مباشرة",
    "创建时间": "وقت الإنشاء",
    "你确定要登出当前账号吗？": "هل تريد تسجيل الخروج؟",
    "请输入你的邮箱": "أدخل بريدك الإلكتروني",
    "好评": "جيد جدًا",
    "条评论": "تقييمات",
    "平均每晚": "المتوسط/ليلة",
    "旅行旅程": "رحلات السفر",
    "正在寻找酒店": "ابحث عن فندق",
    "开始预订": "ابدأ الحجز",
    "旅程价格": "سعر الرحلة",
    "佣金": "العمولات",
    "底部-about": "نحن وكالة تسويق رقمي تساعد الشركات على النجاح في العالم الرقمي من خلال استراتيجيات مبتكرة قائمة على البيانات وخدمة شخصية وعقلية نمو تواكب اتجاهات الصناعة. سواء كنت تحتاج وكالة SEO أو مصمم مواقع أو إدارة إعلانات مدفوعة بالنقرة أو إستراتيجية علامة تجارية أو تطوير محتوى أو خدمات تسويق رقمي أخرى، فلدينا الخبرة لمساعدتك على تحقيق أهدافك.",
    "立即预订": "احجز الآن",
    "搜索": "بحث",
    "快乐的客户": "عملاء سعداء",
    "快乐的酒店老板": "أصحاب فنادق سعداء",
    "评论1": "عمارة على المباني.",
    "评论2": "مكان رائع للتنزه بشوارع ضيقة وعمارة جميلة.",
    "评论3": "ساحة جميلة بين الشاطئ والطريق الرئيسي.",
    "评论4": "مبانٍ جميلة وتاريخ مثير للاهتمام.",
    "评论5": "الكثير من المطاعم وأجواء مريحة للغاية.",
    "评论6": "أرض جميلة مع بساتين برتقال وحيوانات لطيفة.",
    "评论7": "مكان رائع لقضاء عطلة نهاية الأسبوع.",
    "评论8": "مكان مثير للاهتمام...",
    "评论9": "مكان رائع للاسترخاء ومشاهدة العالم من حولك.",
    "评论10": "نادي شاطئي فاخر وتحية جميلة لمن فقدوا في الحرب.",
    "评论11": "هناك الكثير لرؤيته، إنه مكان رائع لقضاء الإجازة والاسترخاء!",
    "评论12": "أول مرة هنا وكانت تجربة ممتعة، سأعود مرة أخرى.",
    "评论13": "تجربة مختلفة ورائعة، السكان المحليون لطفاء للغاية!",
    "推荐计划1": "يمكن لمستخدمي المنصة دعوة الآخرين ليصبحوا وكلاء من خلال رموز الإحالة ويصبحوا ضمن شبكتك.",
    "推荐计划2": "بصفتك الراعي، يمكنك الحصول على نسبة من أرباح شبكتك، ويتم إرجاع الأرباح مباشرة إلى حسابك في المنصة أو إلى تقرير الفريق.",
    "推荐计划3": "ملاحظة: جميع الوكلاء/الأعضاء في الشبكة يحصلون على نسبة من أرباح ومكافآت المنصة وفقًا للسياسة، وتشكيل فريق لا يؤثر على أرباح أي طرف.",
    "评分": "تقييم",
    "评论": "تعليق",
    "酒店很棒": "الفندق رائع",
    "终于体验了，酒店非常好": "أخيرًا جربته، الفندق ممتاز",
    "我对酒店非常满意并推荐预订": "أنا راضٍ جدًا عن الفندق وأنصح بالحجز",
    "我很高兴很满意，价格实惠": "سعيد جدًا وراضٍ، والسعر مناسب",
    "服务非常好，我非常喜欢": "الخدمة ممتازة وأعجبتني جدًا",
    "体验很不错，朋友已经第二次预订了": "تجربة رائعة، وصديقي حجز للمرة الثانية",
    "酒店环境优美": "بيئة الفندق جميلة",
    "酒店卫生干净": "نظافة الفندق ممتازة",
    "工作人员态度非常好": "طاقم العمل ودود للغاية",
    "酒店服务很棒": "خدمة الفندق رائعة",
    "你还没有设置支付密码，请前往设置": "لم تقم بتعيين كلمة مرور للدفع بعد، الرجاء الإعداد",
    "订单": "طلبات",
    "复制成功": "تم النسخ بنجاح",
    "团队与条件": "الأحكام والشروط",
    "站内信": "رسائل النظام",
    "请联系客服升级会员": "يرجى التواصل مع الدعم لترقية العضوية",
    "我已阅读并同意": "لقد قرأت ووافقت على",
    "注册协议": "اتفاقية التسجيل",
    "忘记密码": "نسيت كلمة المرور",
    "账户明细": "تفاصيل الحساب",
    "时间": "الوقت",
    "类型": "النوع",
    "代理支持": "دعم الوكلاء",
    "冻结金额": "المبلغ المجمّد",

    "点击下面的金蛋抽取奖励": "انقر على البيضة الذهبية أدناه لسحب الجائزة",
    "恭喜您中奖了！": "تهانينا! لقد ربحت",
    "很遗憾，您没有中奖": "للأسف، لم تربح",
    "公告": "إشعار",
    "恭喜您获得彩蛋": "تهانينا! لقد حصلت على بيضة ذهبية",
}


